/**
 * Скролл онлайн-записи внутри visual viewport, чтобы при открытой клавиатуре
 * можно было долистать до полей формы (упрощённый аналог web-master ScreenLayout).
 */

const KEYBOARD_OPEN_DELTA_PX = 120;

function bookingRoot(): HTMLElement | null {
  return document.getElementById('root');
}

let teardown: (() => void) | null = null;

export function initBookingVisualViewport(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  disposeBookingVisualViewport();

  const html = document.documentElement;
  const rootEl = bookingRoot();
  const vv = window.visualViewport;

  if (!rootEl || !vv) return;

  const apply = () => {
    const vvh = Math.round(vv.height);
    const vvo = Math.round(vv.offsetTop);

    html.style.setProperty('--booking-vv-height', `${vvh}px`);
    html.style.setProperty('--booking-vv-offset-top', `${vvo}px`);

    if (window.innerHeight - vvh > KEYBOARD_OPEN_DELTA_PX) {
      html.classList.add('booking-keyboard-open');
    } else {
      html.classList.remove('booking-keyboard-open');
    }

    html.classList.add('booking-vv-scroll-active');

    rootEl.style.position = 'fixed';
    rootEl.style.top = `${vvo}px`;
    rootEl.style.left = '0';
    rootEl.style.right = '0';
    rootEl.style.width = '100%';
    rootEl.style.height = `${vvh}px`;
    rootEl.style.maxHeight = `${vvh}px`;
    rootEl.style.overflowX = 'clip';
    rootEl.style.overflowY = 'auto';
    rootEl.style.overscrollBehavior = 'contain';
    rootEl.style.touchAction = 'pan-y';
    rootEl.style.boxSizing = 'border-box';
    (rootEl.style as CSSStyleDeclaration & { webkitOverflowScrolling?: string }).webkitOverflowScrolling =
      'touch';
  };

  apply();
  vv.addEventListener('resize', apply);
  vv.addEventListener('scroll', apply);
  window.addEventListener('resize', apply);

  teardown = () => {
    vv.removeEventListener('resize', apply);
    vv.removeEventListener('scroll', apply);
    window.removeEventListener('resize', apply);
    html.classList.remove('booking-vv-scroll-active', 'booking-keyboard-open');
    html.style.removeProperty('--booking-vv-height');
    html.style.removeProperty('--booking-vv-offset-top');
    rootEl.style.cssText = '';
  };
}

export function disposeBookingVisualViewport(): void {
  teardown?.();
  teardown = null;
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => disposeBookingVisualViewport());
}
